/**
 * This is where we hook into all of flowplayer event methods, and where we manage the beacon
 */
const api = require('./api');
const debug = require('debug')('streamspot:player:flowplayer');

import React from 'react';
import ReactDOM from 'react-dom';
//import ToggleAudioOnlyButton from './components/ToggleAudioOnlyButton.jsx';

function onLoad(player) {
  //debug('On load: triggered with configuration: ' + JSON.stringify(player.api.conf))
  debug('Playback ENGINE %s', player.api.engine.engineName)
  //debug('On load: playing %j', player.api.conf.clip)
  player.overlayUpdate('video')
  player.overlayTrigger('video')
  player.toggleMenu('hide')
  player.registerActions()

  //if mobile, try to register beacon TODO, put back if mobile not captured, seems redundant
  /*
  if( player.mobile ){

    if( window.globalViewerId == null ){
      debug('beacon: viewerId not set on load for mobile, attempting to set');
      var beaconLive = 0;
      if( player.api.live ){
        beaconLive = 1;
      }
      debug('beacon starting: ssId: ' + player.broadcaster.ssId + ' Live: ' + beaconLive);
      startBeacon(player.broadcaster.ssId, beaconLive);
    } else {
      if( player.api.live ){
        if( window.beaconId ){
          debug('beacon: on resume: viewerId set as: ' + window.globalViewerId);
        } else {
          debug('beaconId not set for viewerId: ' + window.globalViewerId + ', recalling startBeacon');
          startBeacon(player.broadcaster.ssId, 1);
        }
      } else {
        //remove the interval
        if( window.beaconId ){
          debug('clearing beaconId: ' + window.beaconId + ' for VOD');
          clearTimeout(window.beaconId);
          debug('beaconId: ' + window.beaconId + ' terminated');
          delete window.beaconId;
        }
      }
    }
  } */
}

function onResume(player) {
  debug('On Resume: triggered');
  player.appendMenuButton();
  player.appendArchivesButton();
  //player.toggleMenu('hide');
  if (player.api.video.live === true) {
    $(player.flowplayerId).addClass('is-live');
    player.state = 'liveAndBroadcasting';
  }
  if( player.mobile ){
    //debug('attempting unmute')
    Player.api.mute(false)
  }
  player.registerActions();
  //add beacon, if not set, used for autoplay while live where load is not called
  if( window.globalViewerId == null ){
    debug('beacon: viewerId is not set on resume, attempting to set');
    var beaconLive = 0;
    if( player.api.live ){
      beaconLive = 1;
    }
    debug('beacon starting: ssId: ' + player.broadcaster.ssId + ' Live: ' + beaconLive);
    startBeacon(player.broadcaster.ssId, beaconLive);
  } else {
    if( player.api.live ){
      if( window.beaconId ){
        debug('beacon: on resume: viewerId set as: ' + window.globalViewerId);
      } else {
        debug('beaconId not set for viewerId: ' + window.globalViewerId + ', recalling startBeacon');
        startBeacon(player.broadcaster.ssId, 1);
      }
    } else {
      //remove the interval
      if( window.beaconId ){
        debug('clearing beaconId: ' + window.beaconId + ' for VOD');
        clearTimeout(window.beaconId);
        debug('beaconId: ' + window.beaconId + ' terminated');
        delete window.beaconId;
      }
    }
  }
}

function onUnload(player) {
  debug('On Unload: triggered');
  if (player.state === 'liveAndBroadcasting' && player.mobile && player.broadcaster.isBroadcasting) {
    player.state = 'liveAndNotBroadcasting';
  }

  if (player.mobile) {
    if (player.qs.video) {
      player.toggleSingleVideoOverlay('show');
    } else {
      player.toggleHomeOverlay('show');
    }
  }
  //remove beacon, if set
  if( window.globalViewerId != null ){
    debug('beacon: removing viewerId: ' + window.globalViewerId);
    removeBeacon(window.globalViewerId);
  } else {
    debug('beacon: viewerId is not set, does not need to be removed');
  }

}

function onPause(player) {
  debug('On Pause: triggered')
  if( window.globalViewerId != null ){
    debug('beacon: viewerId: ' + window.globalViewerId);
  } else {
    debug('beacon: viewerId is not set');
  }
  /** Removed the "you are watching overlay on pause as it was conflicting with Chromecast"
  if (player.state === 'liveAndBroadcasting' && player.overlay.now !== 'chromecast' && player.overlay.now !== 'fullscreen' && !player.switchingHlsLevels) {
    player.toggleLiveOverlay('show')
  }
  **/
  if (player.switchingHlsLevels) {
    window.Player.switchingHlsLevels = false;
  }
}

function onReady(player) {
  debug('On Ready');
  debug('playing: %s', player.api.video.url)
  if (player.currentVideo.live === true) {
    $(player.flowplayerId).addClass('is-live');
    player.state = 'liveAndBroadcasting';
  }
  /**
  $('.flowplayer').css('width', '99.5%'); // to fix aspect ratio
  window.setTimeout(() => {
    $('.flowplayer').css('width', '100%'); // to fix aspect ratio
  }, 1000); **/

  //if the toolbox isdefined,make sure it's shown
  if($('.fp-ss-toolbox').length){
    $('.fp-ss-toolbox').show();
  }

  //load audio only button
  //debug('BD evaluating if audio only button should be present, live?: ' + player.currentVideo)
  if($('#audioOnlyButton').length === 0 && player.currentVideo.live === true ) {
    //if currentLive is set, check for audio-only manifest
    if( player.currentLive ){
      if( player.currentLive.liveObject.audioOnlyManifest ){
        debug('audio-only enabled, manifest defined in liveObject')
        player.toggleAudioOnlyButton('show')
      } else {
        debug('disabling audio-only, not present in currentLive object')
        player.toggleAudioOnlyButton('hide')
      }
    } else {
      debug('BD toggling audio-only button for live video, no currentLive defined')
      player.toggleAudioOnlyButton('show')
    }
  } else if (player.currentVideo.src.audio_only_hls && player.state == 'video' ){
    debug('BD vodAsset has audio only: ' + player.currentVideo.src.audio_only_hls)
    player.toggleAudioOnlyButton('showVOD')
  } else if ( !player.currentVideo.live ) {
    debug('BD removing audio-only button from on-demand video')
    player.toggleAudioOnlyButton('hide')
  }
}

function onError(player, target, type, error, messageText) {
  let text;
  var errorDetailText = ''
 debug('BD onError function called with error error code: %s',error.code)

  if( error.code == 4 ){
    //if it is a live video, call the API to see if the broadcaster is still live
    var manifestURL = 'not defined'
    if ( error.video.url != '' ){
      manifestURL = error.video.url
    } else {
      if( error.video.src != '' ){
        manifestURL = error.video.src
      }
    }
    if( player.api.live ){
      api.checkisBroadcasting(player.broadcaster.ssId, function(isBroadcasting) {
        if( isBroadcasting ){
          text = 'Error Playing Live Broadcast'
          errorDetailText = 'This broadcast may have been temporarily interrupted, please click the button below to try again (error #101)'
          player.toggleInfoOverlay('show', text, errorDetailText, ['.action-refresh-page'])
        } else {
          text = 'Broadcast Ended or Interrupted'
          errorDetailText = 'This broadcaster is no longer live, please refresh to access additional content and options'
          player.toggleInfoOverlay('show', text, errorDetailText, ['.action-refresh-page'])
        }
      });
    } else {
      //it's VOD
      text = 'Error Playing Archive'
      errorDetailText = 'The requested content could not be loaded, please refresh your browser to try again (error #102)'
      player.toggleInfoOverlay('show', text, errorDetailText, ['.action-refresh-page'])
    }
  } else {
    if ( messageText != '' ){
      errorDetailText = messageText
    }
    player.toggleInfoOverlay('show', 'It seems that something went wrong. Please refresh player', errorDetailText, ['.action-refresh-page']);
    var errorText = 'Error Not Defined'
    //only log if we have an error message
    if ( messageText != '' ){
      errorText = messageText
      debug(Error(errorText));
    }
  }
}

function setCookie(name,value,days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/; SameSite=None; Secure";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}


function startBeacon(id, live) {

  //added to reduce overhead, no longer sending for VOD
  if( !live ){
    debug('beacon bypassed for VOD')
    return
  }

  var viewerId = getCookie("viewerId");
  if (viewerId!==null) {
    debug("retrieved viewerId from cookie: " + viewerId);
    window.globalViewerId = viewerId;
    pingPing(viewerId, id);
    return;
  }

  //first, make sure a beacon is not already set
  if( window.globalViewerId != null ){
    debug('beacon: viewerId is already set as: ' + window.globalViewerId + ', removing before starting another');
    removeBeacon(window.globalViewerId);
  } else {
    debug('beacon: viewerId is not set, starting new beacon');
  }
    var apiKey = '73d4c9e8-2320-4800-a379-6ef591eae4c1';
    var apiURL = 'https://live-analytics.prod.subsplash.io/beacon/viewer';
    if (id != '') {
        $.ajax({
            type: "GET",
            url: apiURL,
            data: {
                'ssId': id,
                'live': live,
                'apiKey': '73d4c9e8-2320-4800-a379-6ef591eae4c1'
            },
            success: function(data) {
                if (data.success) {
                    var viewerId = data.viewerId;
                    debug('beacon start: ' + viewerId);
                    setCookie("viewerId",viewerId,365);
                    debug('set cookie to ' + viewerId);
                    //set global variable
                    window.globalViewerId = viewerId;
                    pingPing(viewerId, id);
                } else {
                    debug('beacon error: ' + data.error);
                }
            }
        })
    }
}

function removeBeacon(viewerId) {
  //bypass for new analytics
  if( window.beaconId ){
    debug('removeBeacon: attempting to remove viewerId: ' + window.globalViewerId + ' for beaconTimeoutId: ' + window.beaconId);
    clearTimeout(window.beaconId);
    debug('removeBeacon: ' + window.beaconId + ' terminated');
    delete window.beaconId;
  } else {
    debug('removeBeacon: no beaconTimeoutId set, no action required');
  }
  return
  //first, make sure a beacon is not already set
    debug('beacon: attempting to remove viewerId: ' + window.globalViewerId);
    var apiKey = '73d4c9e8-2320-4800-a379-6ef591eae4c1';
    var apiURL = 'https://live-analytics.prod.subsplash.io/beacon/removeBeacon';
    if (viewerId != '') {
        $.ajax({
            type: "GET",
            url: apiURL,
            data: {
                'viewerId': viewerId,
                'apiKey': '73d4c9e8-2320-4800-a379-6ef591eae4c1'
            },
            success: function(data) {
                if (data.success) {
                    var viewerId = data.data.viewerId;
                    debug('beacon removed for viewerId: ' + viewerId);
                    //delete global variable
                    delete window.globalViewerId;;
                } else {
                    debug('beacon removal error: ' + data.error);
                }
            }
        })
    }
}

function pingPing(viewerId, id) {
    var apiKey = '73d4c9e8-2320-4800-a379-6ef591eae4c1';
    var apiURL = 'https://live-analytics.prod.subsplash.io/beacon/ping';
    if (viewerId != '') {
        $.ajax({
            type: "GET",
            url: apiURL,
            data: {
                'viewerId': viewerId,
                'ssId': id,
                'apiKey': '73d4c9e8-2320-4800-a379-6ef591eae4c1'
            },
            success: function(data) {
                if (data.success) {
                    //just shy of 5-minutes
                    var beaconId = setTimeout(pingPing, 298000, viewerId, id)
                    window.beaconId = beaconId;
                    debug('beacon: ping ' + data.viewerId + ', beaconTimoutId: ' + window.beaconId);
                } else {
                  debug(viewerId + ' beacon terminated')
                }
            }
        })
    }
}

function shortCuts(e, keyPressed, player){
  //debug('key pressed: ' + keyPressed)
  if( $('input:focus').length > 0 ){
    //debug('form input is focused, allowing all keys')
  } else {
    //start space bar actions
    if( keyPressed == 32 ){
      //debug('preventing default')
      e.preventDefault();
      if( $(player.flowplayerId).hasClass('is-splash') ){
        debug('in is-splash state checking #player-overlay for appropriate class to determine action')
        if( $('#player-overlay').hasClass('watch-live-broadcast') ){
          debug('watch-live-broadcast class found, starting broadcast')
          //have space toggle the live broadcast
          player.loadLiveStatic()
        } else {
          //toggle not playing info
          if( $('#player-overlay').hasClass('home-overlay') ){
            debug('home-overlay class -> showing info overlay')
            player.overlayTrigger('info')
          } else if( $('#player-overlay').hasClass('info-overlay') ){
            debug('info-overlay class -> returning to home overlay')
            player.toggleInfoOverlay('hide')
          } else if( $('#player-overlay').hasClass('single-video-overlay') ){
            debug('single-video-overlay class -> loading video')
            player.play(Player.video)
          }
        }
      } else {
        //start pause workflow
        if( player.api.playing ){
          debug('pausing player')
          //allow pause
          Player.api.pause()
        }
        if( player.api.paused){
          debug('resuming player')
          //allow pause
          Player.api.resume()
        }
      }
    }
    //start arrows
    if( !$(player.flowplayerId).hasClass('is-splash') && !$(player.flowplayerId).hasClass('is-error') ){
      if( keyPressed >= 37 && keyPressed <= 40 ){
        if( $(player.flowplayerId).hasClass('is-mouseover') ){
          debug('preventing default due to mouseover')
          e.preventDefault();
        }
        if( !Player.api.live ){ //disallow seeking during live, for now
          //debug('arrow key detected: ' + keyPressed)
          if( keyPressed == 37 ){
            debug('seeking backwards')
            Player.api.seek(false)
          }
          if( keyPressed == 39 ){
            debug('seeking forward')
            Player.api.seek(true)
          }
        }
        //start volume workflow
        if( keyPressed == 38 || keyPressed == 40 ){
          var currentVolume = player.api.volumeLevel
          debug('current volume is ' + currentVolume)
          if( keyPressed == 38 ){
            var setVolumeTo = Math.round((parseFloat(currentVolume) + parseFloat(.1)) * 100) / 100
            if( setVolumeTo > 1 ){
              setVolumeTo = 1
            }
            //setVolumeTo = Math.round( setVolumeTo * 10) / 10
            debug('increasing volume to ' + setVolumeTo)
            Player.api.volume(setVolumeTo)
          }
          if( keyPressed == 40 ){
            var setVolumeTo = Math.round((parseFloat(currentVolume) - parseFloat(.1)) * 100) / 100
            if( setVolumeTo < 0  ){
              setVolumeTo = 0
            }
            //setVolumeTo = Math.round( setVolumeTo * 10) / 10
            debug('decreasing volume to ' + setVolumeTo)
            Player.api.volume(setVolumeTo)
          }
        }
      }
      //start aux keys
      if( keyPressed == 70 ){
        debug('fullscreen toggle')
        Player.api.fullscreen()
      }
      if( Player.api.playing ){
        if( keyPressed == 77 ){
          if( Player.api.muted ){
            debug('unmuting')
            Player.api.mute(false)
          } else {
            debug('muting')
            Player.api.mute(true)
          }
        }
      }
    }
  }
}

module.exports ={
  registerEventHandlers: function(Player){
    if( !Player.mobile ){
     $(document).unbind('keydown').bind('keydown', function (e) {
        shortCuts(e, e.which, Player)
      })
    }
    Player.api.on('load', function() {
      sessionStorage.errorCount = 0; //reset the counter
      onLoad(Player)
    })
    Player.api.on('unload', function() {
      sessionStorage.errorCount = 0; //reset the counter
      onUnload(Player)
    })
    Player.api.on('ready', function() {
      sessionStorage.errorCount = 0; //reset the counter
      onReady(Player)
      //if adpative bitrate, set current resolution on the bar
      //if( Player.broadcaster.isMBR && Player.api.live ){
      if($('.fp-qsel').length){
        if( Player.currentHlsLevel != "" ){
          //update the "HD" button with the font-awesome gear
         debug('BD MBR detected, replacing HD with gear')
          if( Player.highDefHLS ){
            $(".fp-qsel").html('<i class="fa fa-cog"></i><span class="hd-indicator">HD</span>');
          } else {
            $(".fp-qsel").html('<i class="fa fa-cog"></i>');
          }
        }
      }
      //debug('Current speed %s',Player.api.currentSpeed)
      if( Player.api.currentSpeed != 1 ){
        //debug('setting speed to 1 using API')
        Player.api.speed(1)
      }
      if( Player.api.live ){
        //debug('BD hiding speed control on control bar for live')
        $(".fp-speed").hide();
      } else {
        //debug('BD showing speed control on control bar for VOD')
        $(".fp-speed").show();
      }
      if( document.querySelector(".fp-chromecast") ){
        //debug('attempting to move chromecast icon')
        document.querySelector(".fp-controls").appendChild(document.querySelector(".fp-chromecast"))
      }
      if( document.querySelector(".fp-fullscreen") ){
        //debug('attempting to move fullscreen icon')
        document.querySelector(".fp-controls").appendChild(document.querySelector(".fp-fullscreen"))
      }
      if( Player.mobile ){
        //debug('resetting bypass for fullscreen exit on mobile')
        Player.bypassFullscreenMobile = false
      }
      Player.toggleLiveButton()
    })
    Player.api.on('pause', function() {
      onPause(Player)
    })
    Player.api.on('hlsError', function (e, api, data) {
      if (typeof data !== 'undefined') {
        var errorType = data.type;
        var errorDetails = data.details;
        var errorFatal = data.fatal;

        //fallback to string
        debug('HLSJS Error -> Fatal: ' + errorFatal + ', type: ' + errorType + ', details: ' + errorDetails)
        //if fatal, send the message
        if( errorFatal ){
          debug('fatal HLSJS error, sending message')
          text = 'Error During Playback'
          errorDetailText = 'The broadcast or video could not be played at this time, please click the button below to try again (error #102)'
          Player.toggleInfoOverlay('show', text, errorDetailText, ['.action-refresh-page'])
        } else {
          //run count, if > 50 entries, send error messsage
          if( !errorFatal && errorType == 'networkError' && Player.api.live ){
            if (sessionStorage.errorCount) {
              sessionStorage.errorCount = Number(sessionStorage.errorCount) + 1;
            } else {
              sessionStorage.errorCount = 1;
            }
            if( sessionStorage.errorCount == 50 ){
              debug('network errors equals 50: ' + sessionStorage.errorCount + ', unloading the player')
              Player.api.unload()
              debug('player should be unloaded, displaying message')
              var text = 'Broadcast Ended or Interrupted'
              var errorDetailText = 'This broadcaster may no longer be live or may be having connectivity issues, please refresh to access additional content and options'
              Player.toggleInfoOverlay('show', text, errorDetailText, ['.action-refresh-page'])
            } else {
              debug('network error count: ' + sessionStorage.errorCount)
            }
          }
        }
      }
    })
    Player.api.on('hlsLevelSwitch', function (e, api, data) {
      if (typeof data !== 'undefined') {
        // listen to Hls.Events.LEVEL_SWITCH
        var level = api.engine.hlsjs.levels[data.level];
        debug("switched to hls level index:", data.level);
        debug("Resolution: " + level.width + "x" + level.height);
        //if( Player.broadcaster.isMBR ){
          //update the "HD" button with the font-awesome gear
          //debug('BD replacing HD on control bar with ' + level.height + 'p')
          if( level.height >= 720 ){
            //$(".fp-qsel").text(level.height + 'p HD');
            $(".fp-qsel").html('<i class="fa fa-cog"></i><span class="hd-indicator">HD</span>');
          } else {
            //$(".fp-qsel").text(level.height + 'p');
            $(".fp-qsel").html('<i class="fa fa-cog"></i>');
          }
          //store the variable globally in the event the player loading missed it
          Player.currentHlsLevel = level.height + 'p'
          Player.highDefHLS = false;
          if( level.height >= 720 ){
            Player.currentHlsLevel = Player.currentHlsLevel + ' HD'
            Player.highDefHLS = true;
          }
        //} //used to be the MBR check, re-implement if it's not working
      }
    })
    Player.api.on('error', function(target, type, error) {
     //debug('BD error triggered: %j', error)
      //try to get the contents fo fp-message for better explanation
      var messageText = ''
      messageText = $(".fp-message.fp-shown").text();
      onError(Player, target, type, error, messageText)
      debug('BD error message text: %s', messageText)
    })
    Player.api.on('resume', function() {
      onResume(Player)
      if( Player.mobile ){
       //debug('BD muted? %s',Player.api.muted)
      }
      if( !Player.bypassFullscreenMobile ){
        if( Player.mobile ){
          if( !Player.api.isFullscreen ){
            //debug('attempting native-fullscreen')
            Player.api.fullscreen()
          }
        }
      }
      /**
      if( Player.isSafari && !Player.airPlayMoved ){
        if( document.querySelector(".fp-airplay") ){
          debug('attempting to move airplay icon')
          Player.airPlayMoved = true
          document.querySelector(".fp-controls").appendChild(document.querySelector(".fp-airplay"))
        }
      } **/
    })
    Player.api.on('finish', function() {
      //remove beacon, if set
      if( window.globalViewerId != null ){
        debug('beacon: removing viewerId: ' + window.globalViewerId);
        removeBeacon(window.globalViewerId);
      } else {
        debug('beacon: viewerId is not set, does not need to be removed');
      }
    })
    Player.api.on('shutdown', function() {
      //remove beacon, if set
      if( window.globalViewerId != null ){
        debug('beacon: removing viewerId: ' + window.globalViewerId);
        removeBeacon(window.globalViewerId);
      } else {
        debug('beacon: viewerId is not set, does not need to be removed');
      }
    })
    Player.api.on('progress', function() {
      //add functions here to check every .25 seconds
      /**
      if( Player.isSafari && !Player.airPlayMoved ){
        if( document.querySelector(".fp-airplay") ){
          debug('attempting to move airplay icon')
          Player.airPlayMoved = true
          document.querySelector(".fp-controls").appendChild(document.querySelector(".fp-airplay"))
        }
      } **/
    })
    Player.api.on('fullscreen-exit', function() {
      if( Player.mobile ){
        //debug('setting bypass for fullscreen exit on mobile')
        Player.bypassFullscreenMobile = true
      }
    })
  }
};



// WEBPACK FOOTER //
// ./src/flowplayer.js